import React from 'react';
import PropTypes from 'prop-types';

const Down = ({ active, onClick }) => (
  <div
    onClick={active ? onClick : () => {}}
    style={{ cursor: active ? 'pointer' : 'not-allowed', margin: '0px 4px' }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill={active ? '#108ee9' : '#B8B8B8'}
        fillRule="nonzero"
        d="M4.35 15.76a1 1 0 1 1 1.3-1.52L11 18.828V3a1 1 0 0 1 2 0v15.824l5.35-4.583a1 1 0 0 1 1.322.018l.087.09a1 1 0 0 1-.108 1.41l-7.002 6a1 1 0 0 1-1.301 0z"
      />
    </svg>
  </div>
);

Down.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Down;
